<template>
  <div id="CourseChatInput">
    <!-- 如果已登录显示输入框否则显示提示登录 -->
    <div v-if="isLogin" class="input-text">
      <template v-if="course.state === COURSE_STATE.FORECAST">
        <p class="text">直播尚未开始，暂时不能评论 ~</p>
      </template>
      <template v-if="course.state === COURSE_STATE.LIVING || course.chatGroupOpenFlag">
        <textarea
          spellcheck="false"
          placeholder="发表评论 ~"
          ref="textarea"
          v-model="inputText"
          @keydown.enter.exact.prevent="sendMsg(MSG_TYPE.TEXT)"
          @focus="textareaFocusEvent"
        ></textarea>
        <template>
          <img class="ico" v-if="nowPanel === PANEL.EXPRESSION" src="@/assets/svg/icon-keyboard.svg" @click="textareaOnFocus">
          <img class="ico" v-else src="@/assets/svg/icon-emoji.svg" @click="nowPanel = PANEL.EXPRESSION">
          <img class="ico" src="@/assets/svg/icon-gift.svg" @click="nowPanel = PANEL.GIFT">
          <label v-if="!uploadingImg" for="xFile" class="ico">
            <img :src="require('@/assets/svg/add-pic.svg')" style="vertical-align: middle;" alt="">
          </label>
          <img v-else :src="require('@/assets/svg/loding.svg')" width="24" height="24" class="ico animate__roll" alt="">
          <input id="xFile" type="file" accept="image/*" @change="sendFile($event)" ref="addFile" style="position:absolute;clip:rect(0 0 0 0);"/>
        </template>
      </template>
      <template v-if="course.state === COURSE_STATE.ENDED && !course.chatGroupOpenFlag">
        <p class="text">直播已经结束，不能评论 ~</p>
        <VuiButton class="btn-msg" type="text" @click.native="showChatRoomAndCloseOther">
          <img class="ico" src="@/assets/svg/icon-chatting.svg">
          <span class="msgsnum">{{ msgsNum }}</span>
        </VuiButton>
      </template>
      <VuiSpin v-if="course.state > 2 && !imIsConnected"></VuiSpin>
    </div>
    <div v-else class="login-tip">
      <span class="text">解锁聊天室和直播</span>
      <VuiButton type="warning" round @click.native="$router.push({ name: 'Login' })">登录</VuiButton>
    </div>

    <div v-if="showAirTip" class="air-tip" :class="{ 'is-login': this.isLogin }">
      {{ this.isLogin ? '开播了，点这里与大家互动吧~' : '开播了，点这里登录与大家互动吧~' }}
    </div>

    <div v-if="nowPanel === PANEL.EXPRESSION" class="input-expression">
      <img
        v-for="(v, id) in emoticonTable"
        :key="id"
        :src="`/img/expression/${v}`"
        @click="selectedEmoticon(id)"
      >
    </div>
    <!-- 礼物发送 -->
    <course-gift :show="nowPanel === PANEL.GIFT"
      :selectedGift="selectedGift"
      :imIsConnected="imIsConnected"
      @hide="nowPanel = PANEL.NONE"
      @send="sendGift"
      @select="selectGift"></course-gift>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ENUM } from '@/utils'
import { CONSUME_TYPE, COURSE_STATE } from '@/constant/constants'
import ChatBus from '@/bus/chat'
import CourseGift from './CourseGift'

export default {
  name: 'CourseChatInput',
  components: { CourseGift },
  props: {
    imIsConnected: Boolean,
    course: Object,
    chat: Object,
    msgsNum: [Number, String],
    uploadingImg: Boolean,
  },
  data () {
    const PANEL = ENUM('NONE', 'EXPRESSION', 'GIFT')

    return {
      PANEL,
      MSG_TYPE: ENUM('TEXT', 'EXPRESSION', 'GIFT', 'IMAGE'),
      nowPanel: PANEL.NONE,
      nowTab: 'msgs',
      // 输入相关变量
      inputText: '',
      selectedGift: {}, // 当前选中的 Gift
      atMembers: [],
      // 气泡提示
      showAirTip: false,
      // 是否正在进行
      runing: false,
      COURSE_STATE,
    }
  },
  watch: {
    imIsConnected (val) {
      if (val) {
        if (!this.runing) {
          if (this.course.state === COURSE_STATE.LIVING) {
            this.$emit('toggleChatRoom', true)
          }
          this.runing = true
        }
      }
    },
    'course.state' (val, oldVal) {
      if (val === COURSE_STATE.LIVING && oldVal === COURSE_STATE.FORECAST) {
        // 直播前 -> 直播中
        this.showAirTip = true
      } else if (val === COURSE_STATE.LIVING) {
        // 直播状态变为直播中，但不是从直播前变过来的

        if (!this.isLogin) {
          this.showAirTip = true
        }
      }
    },
  },
  computed: {
    ...mapState('app', ['isLogin']),
    ...mapState('chat', ['accid', 'expressionTable', 'giftTable', 'emoticonTable', 'role']),
  },
  methods: {
    //
    textareaOnFocus () {
      const index = this.inputText.length

      this.$refs.textarea.focus()
      this.$refs.textarea.setSelectionRange(index, index)
    },
    // 输入框获取焦点时在移动端应当将 body 上移防止输入框位置不对
    textareaFocusEvent () {
      this.showChatRoomAndCloseOther()
      ChatBus.$emit('showTabMsgs')
    },
    showChatRoomAndCloseOther () {
      this.showAirTip = false
      this.nowPanel = this.PANEL.NONE
      this.$emit('toggleChatRoom', true)
    },
    setAt ({ accid, name }) {
      const hasNowAccid = this.atMembers.some(m => m.accid === accid)

      if (!hasNowAccid) {
        this.atMembers.push({ name, accid })
      }

      if (!this.inputText.includes(`@${name}`)) {
        this.inputText = `@${name} ${this.inputText}`
      }
    },
    // 选中表情写入到输入框内
    selectedEmoticon (emoticonId) {
      this.inputText += emoticonId
    },
    // 整合后的发送消息（文本，表情，礼物）
    sendMsg (msgType, payload) {
      // 发送前所需要做的准备
      const sendData = { ext: {} }

      switch (msgType) {
        case this.MSG_TYPE.TEXT:
          // 如果输入框内为空字符串
          if (this.inputText.trim() === '') {
            this.inputText = ''
            return
          }

          // 如果存在 @ 列表，进行列表与输入框内值得对应检测，并附加到数据上
          if (this.atMembers.length > 0) {
            this.atMembers = this.atMembers.filter(({ name }) => {
              return this.inputText.includes(`@${name}`)
            })

            if (this.atMembers.length > 0) {
              sendData.ext.remoteExt = this.atMembers.map(m => m.accid)
            }
          }

          // 添加发送 TEXT 所需要的相应字段
          sendData.type = 'text'
          sendData.text = this.inputText
          break
        case this.MSG_TYPE.EXPRESSION:
          // 添加发送 EXPRESSION 所需要的相应字段
          sendData.type = 'custom'
          sendData.content = JSON.stringify({ type: 'expression', id: payload.id })
          break
      }

      // 需要全局添加的发送数据
      sendData.ext.role = this.role
      sendData.custom = JSON.stringify(sendData.ext)
      sendData.chatroomId = this.course.chatGroup
      this.$emit('sendMsg', { msgData: sendData })

      switch (msgType) {
        case this.MSG_TYPE.TEXT:
          // 重置输入框和 @ 列表
          this.inputText = ''
          this.atMembers = []
          break
        case this.MSG_TYPE.EXPRESSION:
          break
      }
    },
    selectGift (gift) {
      this.selectedGift = gift
    },
    sendGift (data) {
      if (this.isSending) {
        this.$Message.info('礼物发送中...')
        return
      }
      this.isSending = true
      // 发送礼物
      let sendData = {
        attach: JSON.stringify({ type: 'gift', id: this.selectedGift.value }),
        consumeType: this.selectedGift.consumeType,
        consumeValue: this.selectedGift.consumeType === CONSUME_TYPE.COIN.value ? this.selectedGift.coinCost : this.selectedGift.diamondCost,
        ext: JSON.stringify({ role: this.role }),
        roomid: this.course.chatGroup,
        msgType: 100, // 发送文本消息
      }
      this.$store.dispatch('chat/sendGift', sendData).then(data => {
        this.selectedGift = {}
        this.nowPanel = this.PANEL.NONE
        this.isSending = false
        // 发送成功列表增加礼物，否则提示发送失败细腻
        if (data.successFlag) {
          // 发送结束后回调
          this.$emit('sendGift', data)
        } else {
          this.$Message.error(data.flagMsg)
        }
      })
    },
    sendFile (event) {
      this.$emit('sendFile', event)
    },
  },
  mounted () {
    ChatBus.$on('setAt', this.setAt)
    ChatBus.$on('inputFocus', this.textareaOnFocus)
    ChatBus.$on('changeTab', (tab) => { this.nowTab = tab })
    this.runing = true
  },
}
</script>

<style lang="scss">
$input-height: 44px;

#CourseChatInput {
  position: relative;
  background-color: #ffffff;

  .input-text {
    @include wh(100%, $input-height);
    padding: 6px;
    padding-right: 16px;
    border-top: 1px solid #d8d8d8;
    display: flex;
    justify-content: space-between;
    align-items: center;

    textarea {
      @include wh(auto, 100%);
      @include font(12px, 17px, rgba(0, 0, 0, 0.8));
      border: 1px solid rgba(0, 0, 0, 0.1);
      background-color: rgba(248, 248, 248, 0.82);
      padding: 6px 8px;
      border-radius: 3px;
      flex-grow: 1;
      resize: none;
      outline: none;
      overflow: auto;
      -webkit-appearance: none;

      &::-webkit-input-placeholder {
        color: rgba(0, 0, 0, 0.2);
      }
    }

    .text {
      @include font(14px, initial, #4a4a4a);
      padding-left: 14px;
      flex-grow: 1;
    }

    .ico {
      margin-left: 16px;
      cursor: pointer;
    }

    .btn-msg {
      margin: 0;
      padding: 0;

      * {
        vertical-align: middle;
      }
    }

    .msgsnum {
      @include font(16px, 24px, #8590a6);
      margin-left: 4px;
      cursor: pointer;
    }
  }

  .input-expression {
    @include wh(340px, 156px);
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-content: space-around;

    img {
      @include wh(48px, 48px);
      margin: 10px;
      flex-shrink: 0;
      flex-grow: 0;
      cursor: pointer;
    }
  }
  .login-tip {
    @include wh(100%, $input-height);
    padding: 6px 10px;
    border-top: 1px solid #d8d8d8;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      @include font(14px, initial, #868688, 1px);
    }
  }

  .air-tip {
    @include font(14px, 20px, #ffffff);
    position: absolute;
    bottom: $input-height + 4px;
    left: auto;
    right: 6px;
    padding: 14px 16px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 4;

    &::after {
      content: '';
      width: 0;
      height: 0;
      box-sizing: content-box;
      border-width: 6px;
      border-style: solid;
      border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
      position: absolute;
      bottom: -12px;
      left: auto;
      right: 24px;
    }

    &.is-login {
      left: 6px;
      right: auto;

      &::after {
        left: 24px;
        right: auto;
      }
    }
  }
}

.animate__roll {
  animation: roll 2s ease-in infinite;
}
@keyframes roll {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
